import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import Button from '../../../Button'
import { FormFieldsContainer } from '../../../Form'
import { Skeleton } from '../../../Skeleton'
import Text from '../../../Text'
import { getMappingRowKey } from '../EditBuildingAndCategoryModal.utils'

import { MappingRow } from './MappingRow'

import * as styles from './EditBuildingAndCategoryModalFormFields.module.css'

import PlusIcon from '../../../../icons/plus.svg'

function EditBuildingAndCategoryModalFormFields({
  canAddMappingRow,
  isLoading,
  isSubmitting,
  mappingRows,
  name,
  onAddMappingRow,
  onRemoveMappingRow,
}) {
  const { t } = useTranslation()

  const isSingleRow = mappingRows.length === 1

  return (
    <>
      {name ? (
        <Text isSecondary className={styles.providerName}>
          {isLoading ? (
            <Skeleton className={styles.providerNameSkeleton} />
          ) : (
            <>
              {t('Provider.EditBuildingAndCategoryProviderNameKey')}: {name}
            </>
          )}
        </Text>
      ) : null}
      <FormFieldsContainer className={styles.container}>
        {mappingRows.map((row, index) => {
          const rowKey = getMappingRowKey({ index, row })

          return (
            <MappingRow
              deleteTooltip={
                isSingleRow
                  ? t('Provider.CannotDeleteSingleMappingTooltipKey')
                  : t('Provider.MappingDeleteBtnTooltipKey')
              }
              deleteTooltipPlacement={
                isSingleRow
                  ? FLOATING_ELEMENT_PLACEMENT.topEnd
                  : FLOATING_ELEMENT_PLACEMENT.top
              }
              index={index}
              isDeleteDisabled={isSubmitting || isSingleRow}
              isLoading={isLoading}
              isSubmitting={isSubmitting}
              key={rowKey}
              onRemoveMappingRow={onRemoveMappingRow}
            />
          )
        })}
        <Button.Text
          beforeIconProps={{ Icon: PlusIcon }}
          className={styles.addMappingRowButton}
          disabled={isSubmitting || !canAddMappingRow}
          isSkeleton={isLoading}
          text={t('Provider.AddMappingRowButtonKey')}
          tooltip={
            !canAddMappingRow
              ? t('Provider.CannotAddNewMappingTooltipKey')
              : null
          }
          tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.right}
          onClick={onAddMappingRow}
        />
      </FormFieldsContainer>
    </>
  )
}

export default EditBuildingAndCategoryModalFormFields
